export enum BankAccountHolderTypeAPI {
  PERSONAL,
  BUSINESS,
}
